(function () {
  /*
   * CHASKI CACAO CART MAPPING
   */
  var ONE_TIME_VARIANT_ID = '56783088058754';
  var THREE_MONTH_VARIANT_ID = '56783088091522';

  var MONTHLY_PLAN_ID = '711086571906';
  var THREE_MONTH_PLAN_ID = '711178879362';

  var MONTHLY_LABEL = 'Delivery Every 30 Days';
  var THREE_MONTH_LABEL = 'Delivery Every 3 Months';

  var isSwitching = false;
  var listenerAttached = false;

  /*
   * Get access to UpCart's shadow DOM.
   */
  function getUpCartRoot() {
    var host = document.getElementById('upCart');

    if (!host || !host.shadowRoot) {
      return null;
    }

    return host.shadowRoot;
  }

  /*
   * Fix labels and inject the missing cross-variant options.
   */
  function updateChaskiDropdowns() {
    var root = getUpCartRoot();

    if (!root) {
      return;
    }

    var selects = root.querySelectorAll('select');

    selects.forEach(function (select) {
      /*
       * Find only the GENUINE monthly option.
       * Ignore our custom injected monthly option.
       */
      var existingMonthlyOption = select.querySelector(
        'option[value="' +
          MONTHLY_PLAN_ID +
          '"]:not([data-chaski-monthly="true"])'
      );

      if (existingMonthlyOption) {
        existingMonthlyOption.textContent =
          MONTHLY_LABEL;
      }

      /*
       * Find only the GENUINE 3-month option.
       * Ignore our custom injected 3-month option.
       */
      var existingThreeMonthOption = select.querySelector(
        'option[value="' +
          THREE_MONTH_PLAN_ID +
          '"]:not([data-chaski-three-month="true"])'
      );

      if (existingThreeMonthOption) {
        existingThreeMonthOption.textContent =
          THREE_MONTH_LABEL;
      }

      /*
       * Find the subscription optgroup.
       */
      var subscriptionGroup = null;
      var groups = select.querySelectorAll('optgroup');

      groups.forEach(function (group) {
        if (group.label === 'Subscription plans') {
          subscriptionGroup = group;
        }
      });

      if (!subscriptionGroup) {
        return;
      }

      /*
       * If this dropdown contains the genuine monthly plan,
       * it belongs to the 1 Tube variant.
       *
       * Inject the custom 90-day option.
       */
      if (existingMonthlyOption) {
        if (
          !select.querySelector(
            'option[data-chaski-three-month="true"]'
          )
        ) {
          var newThreeMonthOption =
            document.createElement('option');

          newThreeMonthOption.value =
            THREE_MONTH_PLAN_ID;

          newThreeMonthOption.textContent =
            THREE_MONTH_LABEL;

          newThreeMonthOption.setAttribute(
            'data-chaski-three-month',
            'true'
          );

          subscriptionGroup.appendChild(
            newThreeMonthOption
          );
        }
      }

      /*
       * If this dropdown contains the genuine 3-month plan,
       * it belongs to the 3 Tubes variant.
       *
       * Inject the custom 30-day option.
       */
      if (existingThreeMonthOption) {
        if (
          !select.querySelector(
            'option[data-chaski-monthly="true"]'
          )
        ) {
          var newMonthlyOption =
            document.createElement('option');

          newMonthlyOption.value =
            MONTHLY_PLAN_ID;

          newMonthlyOption.textContent =
            MONTHLY_LABEL;

          newMonthlyOption.setAttribute(
            'data-chaski-monthly',
            'true'
          );

          /*
           * Put the 30-day option before the 3-month option.
           */
          subscriptionGroup.insertBefore(
            newMonthlyOption,
            existingThreeMonthOption
          );
        }
      }
    });
  }

  /*
   * Reapply dropdown changes after UpCart redraws.
   */
  function runDelayedDropdownFixes() {
    updateChaskiDropdowns();
    setTimeout(updateChaskiDropdowns, 100);
    setTimeout(updateChaskiDropdowns, 300);
    setTimeout(updateChaskiDropdowns, 700);
  }

  /*
   * Tell UpCart the cart has changed.
   */
  function refreshUpCart() {
    window.dispatchEvent(
      new CustomEvent(
        'aftersell-upcart:public-events:cart-updated'
      )
    );

    runDelayedDropdownFixes();
  }

  /*
   * SWITCH:
   * 3 Tubes / Every 3 Months
   * ->
   * 1 Tube / One-time purchase
   */
  async function switchThreeMonthToOneTime() {
    if (isSwitching) {
      return;
    }

    isSwitching = true;

    try {
      /*
       * Read the current cart before changing anything.
       */
      var cartResponse = await fetch('/cart.js', {
        credentials: 'same-origin'
      });

      if (!cartResponse.ok) {
        throw new Error(
          'Could not read cart'
        );
      }

      var cart = await cartResponse.json();

      /*
       * Find the current genuine 3 Tube Chaski line.
       */
      var threeTubeIndex =
        cart.items.findIndex(
          function (item) {
            return (
              String(item.variant_id) ===
                THREE_MONTH_VARIANT_ID &&
              item.product_title ===
                'Chaski Cacao'
            );
          }
        );

      if (threeTubeIndex === -1) {
        throw new Error(
          '3-tube Chaski cart item could not be found'
        );
      }

      var threeTubeItem =
        cart.items[threeTubeIndex];

      var quantity =
        threeTubeItem.quantity || 1;

      /*
       * The cart has not changed yet,
       * so this line number is reliable.
       */
      var threeTubeLineNumber =
        threeTubeIndex + 1;

      /*
       * FIRST remove the existing 90-day item.
       */
      var removeResponse =
        await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type':
              'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            line: threeTubeLineNumber,
            quantity: 0
          })
        });

      if (!removeResponse.ok) {
        var removeError =
          await removeResponse.text();

        throw new Error(
          'Could not remove 3-month item: ' +
            removeError
        );
      }

      /*
       * NOW add the genuine 1 Tube one-time variant.
       */
      var addResponse =
        await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type':
              'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: ONE_TIME_VARIANT_ID,
                quantity: quantity
              }
            ]
          })
        });

      if (!addResponse.ok) {
        var addError =
          await addResponse.text();

        throw new Error(
          'Could not add one-time item: ' +
            addError
        );
      }

      /*
       * Refresh only after both operations are complete.
       */
      refreshUpCart();

    } catch (error) {
      console.error(
        'Chaski 3-month to one-time switch failed:',
        error
      );
    } finally {
      setTimeout(function () {
        isSwitching = false;
      }, 500);
    }
  }

  /*
   * SWITCH:
   * 1 Tube / Monthly subscription
   * OR
   * 1 Tube / One-time purchase
   *
   * ->
   *
   * 3 Tubes / Every 3 Months
   */
  async function switchOneTubeToThreeMonth() {
    if (isSwitching) {
      return;
    }

    isSwitching = true;

    try {
      /*
       * Read the current cart BEFORE making any changes.
       */
      var cartResponse = await fetch('/cart.js', {
        credentials: 'same-origin'
      });

      if (!cartResponse.ok) {
        throw new Error(
          'Could not read cart'
        );
      }

      var cart = await cartResponse.json();

      /*
       * Find the current 1 Tube Chaski line.
       */
      var oneTubeIndex =
        cart.items.findIndex(
          function (item) {
            return (
              String(item.variant_id) ===
                ONE_TIME_VARIANT_ID &&
              item.product_title ===
                'Chaski Cacao'
            );
          }
        );

      if (oneTubeIndex === -1) {
        throw new Error(
          '1-tube Chaski cart item could not be found'
        );
      }

      var oneTubeItem =
        cart.items[oneTubeIndex];

      var quantity =
        oneTubeItem.quantity || 1;

      /*
       * The cart has not changed yet,
       * so this line number is reliable.
       */
      var oneTubeLineNumber =
        oneTubeIndex + 1;

      /*
       * FIRST remove the original 1 Tube item.
       */
      var removeResponse =
        await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type':
              'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            line: oneTubeLineNumber,
            quantity: 0
          })
        });

      if (!removeResponse.ok) {
        var removeError =
          await removeResponse.text();

        throw new Error(
          'Could not remove original 1-tube item: ' +
            removeError
        );
      }

      /*
       * NOW add the genuine 3 Tubes variant
       * with the genuine 3-month selling plan.
       */
      var addResponse =
        await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type':
              'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: THREE_MONTH_VARIANT_ID,
                quantity: quantity,
                selling_plan:
                  THREE_MONTH_PLAN_ID
              }
            ]
          })
        });

      if (!addResponse.ok) {
        var addError =
          await addResponse.text();

        throw new Error(
          'Could not add 3-month item: ' +
            addError
        );
      }

      refreshUpCart();

    } catch (error) {
      console.error(
        'Chaski switch to 3-month failed:',
        error
      );
    } finally {
      setTimeout(function () {
        isSwitching = false;
      }, 500);
    }
  }

  /*
   * SWITCH:
   * 3 Tubes / Every 3 Months
   * ->
   * 1 Tube / Every 30 Days
   */
  async function switchThreeMonthToMonthly() {
    if (isSwitching) {
      return;
    }

    isSwitching = true;

    try {
      /*
       * Read the current cart before changing anything.
       */
      var cartResponse = await fetch('/cart.js', {
        credentials: 'same-origin'
      });

      if (!cartResponse.ok) {
        throw new Error(
          'Could not read cart'
        );
      }

      var cart = await cartResponse.json();

      /*
       * Find the current genuine 3 Tube Chaski line.
       */
      var threeTubeIndex =
        cart.items.findIndex(
          function (item) {
            return (
              String(item.variant_id) ===
                THREE_MONTH_VARIANT_ID &&
              item.product_title ===
                'Chaski Cacao'
            );
          }
        );

      if (threeTubeIndex === -1) {
        throw new Error(
          '3-tube Chaski cart item could not be found'
        );
      }

      var threeTubeItem =
        cart.items[threeTubeIndex];

      var quantity =
        threeTubeItem.quantity || 1;

      /*
       * The cart has not changed yet,
       * so this line number is reliable.
       */
      var threeTubeLineNumber =
        threeTubeIndex + 1;

      /*
       * Remove the 3 Tube 90-day item first.
       */
      var removeResponse =
        await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type':
              'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            line: threeTubeLineNumber,
            quantity: 0
          })
        });

      if (!removeResponse.ok) {
        var removeError =
          await removeResponse.text();

        throw new Error(
          'Could not remove 3-month item: ' +
            removeError
        );
      }

      /*
       * Add the genuine 1 Tube variant
       * with the monthly selling plan.
       */
      var addResponse =
        await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type':
              'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: ONE_TIME_VARIANT_ID,
                quantity: quantity,
                selling_plan:
                  MONTHLY_PLAN_ID
              }
            ]
          })
        });

      if (!addResponse.ok) {
        var addError =
          await addResponse.text();

        throw new Error(
          'Could not add monthly item: ' +
            addError
        );
      }

      refreshUpCart();

    } catch (error) {
      console.error(
        'Chaski switch to monthly failed:',
        error
      );
    } finally {
      setTimeout(function () {
        isSwitching = false;
      }, 500);
    }
  }

  /*
   * Listen for dropdown selections inside UpCart.
   */
  function attachDropdownListener() {
    var root = getUpCartRoot();

    if (!root || listenerAttached) {
      return;
    }

    listenerAttached = true;

    root.addEventListener(
      'change',
      function (event) {
        var select = event.target;

        if (
          !select ||
          select.tagName !== 'SELECT' ||
          isSwitching
        ) {
          return;
        }

        var selectedOption =
          select.options[
            select.selectedIndex
          ];

        if (!selectedOption) {
          return;
        }

        /*
         * CUSTOM 90-DAY OPTION:
         * 1 Tube -> 3 Tubes / Every 3 Months
         */
        if (
          selectedOption.getAttribute(
            'data-chaski-three-month'
          ) === 'true'
        ) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          switchOneTubeToThreeMonth();

          return;
        }

        /*
         * CUSTOM 30-DAY OPTION:
         * 3 Tubes -> 1 Tube / Every 30 Days
         */
        if (
          selectedOption.getAttribute(
            'data-chaski-monthly'
          ) === 'true'
        ) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          switchThreeMonthToMonthly();

          return;
        }

        /*
         * 3-MONTH -> ONE-TIME
         */
        var hasRealThreeMonthPlan =
          select.querySelector(
            'option[value="' +
              THREE_MONTH_PLAN_ID +
              '"]:not([data-chaski-three-month="true"])'
          );

        if (
          hasRealThreeMonthPlan &&
          select.value === 'otp'
        ) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          switchThreeMonthToOneTime();

          return;
        }
      },
      true
    );
  }

  /*
   * Initialise once UpCart exists.
   */
  function initialise() {
    var root = getUpCartRoot();

    if (!root) {
      setTimeout(
        initialise,
        300
      );

      return;
    }

    attachDropdownListener();
    runDelayedDropdownFixes();
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialise
    );
  } else {
    initialise();
  }

  /*
   * Reapply dropdown changes whenever
   * UpCart redraws itself.
   */
  window.addEventListener(
    'aftersell-upcart:public-events:cart-loaded',
    function () {
      attachDropdownListener();
      runDelayedDropdownFixes();
    }
  );

  window.addEventListener(
    'aftersell-upcart:public-events:cart-updated',
    runDelayedDropdownFixes
  );

  window.addEventListener(
    'aftersell-upcart:public-events:added-to-cart',
    runDelayedDropdownFixes
  );
})();